export function formatViews(n: number): string {
  if (n >= 10000) {
    const w = (n / 10000).toFixed(1).replace(/\.0$/, "");
    return `${w}万`;
  }
  return String(n);
}

export function formatCount(n: number): string {
  if (n >= 10000) {
    const w = (n / 10000).toFixed(1).replace(/\.0$/, "");
    return `${w}万`;
  }
  return String(n);
}